"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useBlockDisplayInformation;

var _data = require("@wordpress/data");

var _blocks = require("@wordpress/blocks");

var _store = require("../../store");

/**
 * WordPress dependencies
 */

/**
 * Internal dependencies
 */

/** @typedef {import('@wordpress/blocks').WPIcon} WPIcon */

/**
 * Contains basic block's information for display reasons.
 *
 * @typedef {Object} WPBlockDisplayInformation
 *
 * @property {string} title Human-readable block type label.
 * @property {WPIcon} icon Block type icon.
 * @property {string} description A detailed block type description.
 */

/**
 * Hook used to try to find a matching block variation and return
 * the appropriate information for display reasons. In order to
 * to try to find a match we need to things:
 * 1. Block's client id to extract it's current attributes.
 * 2. A block variation should have set `isActive` prop to a proper function.
 *
 * If for any reason a block variaton match cannot be found,
 * the returned information come from the Block Type.
 * If no blockType is found with the provided clientId, returns null.
 *
 * @param {string} clientId Block's client id.
 * @return {?WPBlockDisplayInformation} Block's display information, or `null` when the block or its type not found.
 */
function useBlockDisplayInformation(clientId) {
  return (0, _data.useSelect)(function (select) {
    if (!clientId) return null;

    var _select = select(_store.store),
        getBlockName = _select.getBlockName,
        getBlockAttributes = _select.getBlockAttributes;

    var _select2 = select(_blocks.store),
        getBlockType = _select2.getBlockType,
        getBlockVariations = _select2.getBlockVariations;

    var blockName = getBlockName(clientId);
    var blockType = getBlockType(blockName);
    if (!blockType) return null;
    var variations = getBlockVariations(blockName);
    var blockTypeInfo = {
      title: blockType.title,
      icon: blockType.icon,
      description: blockType.description
    };
    if (!(variations !== null && variations !== void 0 && variations.length)) return blockTypeInfo;
    var attributes = getBlockAttributes(clientId);
    var match = variations.find(function (variation) {
      var _variation$isActive;

      return (_variation$isActive = variation.isActive) === null || _variation$isActive === void 0 ? void 0 : _variation$isActive.call(variation, attributes, variation.attributes);
    });
    if (!match) return blockTypeInfo;
    return {
      title: match.title || blockType.title,
      icon: match.icon || blockType.icon,
      description: match.description || blockType.description
    };
  }, [clientId]);
}
//# sourceMappingURL=index.js.map